// @flow
import React, { useState, useEffect, useRef, useCallback } from 'react';
import Debug from 'debug';
import { TYPE } from '../../../../constants/targetConstants';

const debug = Debug('amms:modules:tisPlayer:generator:player:item');


type Props = $ReadOnly<{
    isPlaying: boolean,
    item: $ReadOnly<{}>,

    playMessage: () => void
}>;
function PlayerItem({ isPlaying, item, playMessage }: Props) {
    useEffect(() => {
        let timerId;

        if(isPlaying && item.enabled && item.steps && item.steps.length > 0) {
            let i = 0;
            setTimeout(() => {
                const step = () => {
                    if(i >= item.steps.length) {
                        i = 0;
                    }

                    let position;
                    const step = item.steps[i];
                    if(item.generatorType === 'absolute') {
                        position = [step.x, step.y];
                    }
                    else {
                        position = [
                            item.baseCoordinates.x + (step.x * item.stepMultiplier),
                            item.baseCoordinates.y + (step.y * item.stepMultiplier)
                        ];
                    }

                    const tisMessage = {
                        "MovementData": {
                            "Position": position,
                            "GroundTrack": 0,
                            "OnGround": true,
                            "FlightLevel": 0,
                            "VerticalSpeed": 0,
                            "GroundSpeed": 0
                        },
                        "RemoveTrack": false,
                        "Icao": item.icao,
                        "TargetIdentification": item.callsign,
                        "EmitterCategory": item.type === TYPE.car ? 21 : 10,
                        "TimeOfTrackInformation": new Date(),
                        "TrackNumber": 3302,
                        "Squawk": 0,
                        "DataSource": item.dataSource || "SYSTEM"
                    };

                    playMessage(tisMessage);
                    i += 1;
                };

                step();

                timerId = setInterval(step, item.interval);
            }, item.delay);
        }

        return () => {
            clearInterval(timerId);
        };
    }, [isPlaying, item, playMessage]);

    return null;
}

export default PlayerItem;